import src from "IMAGE";
export default { src, width: 500, height: 178, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAR0lEQVR42i3KsQnAIBQG4b9KkS5F1giEkB0sBG0U3MP1XMDWNRzCE17xFQcnSQEVF24cZvcJTQx8KHCISMh7aOg2PDZ4vPgXTZgHgdgIAmIAAAAASUVORK5CYII="};
